import axios from 'axios';
import Cookies from "universal-cookie";
import {handleErrors}  from "./actions";

const cookies = new Cookies();

export function baseUrl() {
  return process.env.REACT_APP_API_BASE_URL;
}

export class BaseApi {
  // TODO: Remove dependency on dispatch and getState
  constructor(dispatch, getState, options = {}) {
    this.dispatch = dispatch;
    this.getState = getState;
    this.options  = options;
  }

  get token() {
    return this.options.token ? this.options.token : cookies.get("jwtToken");
  }

  get headers() {
    let headers = {
      "Content-Type": "application/json",
    }

    headers = { ...headers, ...this.options.headers };

    if(!this.options.noToken) headers["Authorization"] = this.token;
    return headers;
  }

  getRequest = (
    url,
    onSuccess = (response) => {},
    onError = (errors) => {},
    withCredentials = false,
    shouldHandleErrors = true,
    params = {},
  ) => {
    axios(
      url,
      {
        params: params,
        headers: this.headers,
        withCredentials
      }
    )
    .then(response => {
      onSuccess(response)
    })
    .catch(errors => {
      console.error(errors)
      onError(errors)
      if (shouldHandleErrors) { this.dispatch(handleErrors(errors.response)) }
    })
  }

  postRequest = (
    url,
    data = null,
    onSuccess = (response) => {},
    onError = (errors) => {},
    cancelToken = null,
  ) => {
    axios(
      url,
      {
        cancelToken,
        data: data,
        headers: this.headers,
        method: "POST",
      }
    )
    .then(response => {
      onSuccess(response)
    })
    .catch(errors => {
      if (axios.isCancel(errors)) { return console.warn("cancelled:", errors) }
      console.error(errors)
      onError(errors)
      this.dispatch(handleErrors(errors.response))
    })
  }

  putRequest = (
    url,
    data = null,
    onSuccess = (response) => {},
    onError = (errors) => {},
  ) => {
    axios(
      url,
      {
        method: "PUT",
        headers: this.headers,
        data: data,
      }
    )
    .then(response => {
      onSuccess(response)
    })
    .catch(errors => {
      console.error(errors)
      onError(errors)
      this.dispatch(handleErrors(errors.response))
    })
  }
}



// WEBPACK FOOTER //
// ./src/features/shared/api.js